import type { StandingOrders } from './StandingOrders';

export const SK: Partial<StandingOrders> = {
    // remove after SO refactoring in favor of switchable sweepOrder flag below
    createSweepOrders: false,
    standingOrderIntervals: ['DAILY', 'WEEKLY', 'MONTHLY', 'QUARTERLY', 'HALFYEARLY', 'YEARLY'],
    daysOfRepetition: 14,
    /* Ensures to always use DUE_DAY_OF_MONTH */
    daysUntilLastOfMonth: 100,
    daysUntilLastOfMonthSweep: 100,
    useVariableCurrencyForIntrabankIban: true,
    executionModes: [
        'UNTIL_CANCELLATION',
        'UNTIL_DATE',
        'AFTER_MAX_ITERATION_EXCEEDED',
        'AFTER_MAX_AMOUNT_EXCEEDED',
    ],
    executionModesSweep: [
        'UNTIL_CANCELLATION',
        'UNTIL_DATE',
        'AFTER_MAX_ITERATION_EXCEEDED',
        'AFTER_MAX_AMOUNT_EXCEEDED',
    ],
    disableCurrencySelectOnEdit: true,
    disableExecutionIntervalSelectOnEdit: true,
    historyScheduledExecutionDates: true,
};
